import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

export default function AuthCallback() {
    const { fetchMe } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const plan = params.get('plan');

        if (!token) {
            navigate('/login?error=oauth');
            return;
        }

        localStorage.setItem('ss_token', token);

        fetchMe().then(() => {
            if (plan) {
                navigate(`/checkout-options?plan=${plan}`);
            } else {
                navigate('/dashboard');
            }
        });
    }, [fetchMe, navigate]);

    return <LoadingSpinner fullPage text="Signing you in..." />;
}
